import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        
        {/* Social Media Links */}
        <a
          href="https://discord.gg/p3TqMMJX"
          className="footer-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Discord
        </a>

        <a
          href="https://www.instagram.com/enrichify.io/"
          className="footer-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Instagram
        </a>
      </div>
    </footer>
  );
}

export default Footer;